  <div class="container">
    <div  class="member-form"> 
      <div style="text-align: center; padding: 44px 0 0 0;">
        <img
          width="88"
          alt="Zulu logo"
          src="/assets/images/logo.jpg"
        />
    </div>
      
      <div class="content">
        <div class="card-container" style="max-width: 540px; background-color: white;">
          <a class="card">
            <span><img src="assets/images/lang1.png" width="80" class="flag" (click)="selectLang(0)"></span>
          </a>
          <a class="card">
            <span><img src="assets/images/lang2.png" width="80" class="flag" (click)="selectLang(1)"></span>
          </a>
          <a class="card">
            <span><img src="assets/images/lang3.png" width="80" class="flag" (click)="selectLang(2)"></span>
          </a>
          <a class="card">
            <span><img src="assets/images/lang4.png" width="80" class="flag" (click)="selectLang(3)"></span>
          </a>
          <a class="card">
            <span><img src="assets/images/lang5.png" width="80" class="flag" (click)="selectLang(4)"></span>
          </a>
          <a class="card">
            <span><img src="assets/images/lang6.png" width="80" class="flag" (click)="selectLang(5)"></span>
          </a>
        </div>
      </div>
    </div>
  </div>